module.exports = __webpack_public_path__ + "img/c_occupancy rate.ae2d1b2e.svg";